import { DataNode } from "antd/lib/tree";
import { IGroupOptions } from "../SelectGroup/interface";

/**
 * 是否在移动端打开
 * @returns boolean
 */
export function isMobile(): boolean {
  if (
    navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i,
    )
  ) {
    return true;
  }
  return false;
}

export function dataToTreeData(
  data: any[],
  titleKey: string,
  valueKey: string,
  childrenKey: string,
): DataNode[] {
  let treeData: DataNode[] = [];
  if (Array.isArray(data) && data.length) {
    treeData = data.map(item => {
      const children = item[childrenKey];
      const title = item[titleKey];
      const value = item[valueKey];
      if (Array.isArray(children) && children.length) {
        return {
          title,
          key: value,
          children: dataToTreeData(children, titleKey, valueKey, childrenKey),
        };
      }
      return { title, key: value };
    });
  }
  return treeData;
}


export function dataToOptionData(
  data: any[],
  labelKey: string,
  valueKey: string,
  childrenKey: string,
  groupLabelKey: string,
  groupValueKey: string,
): IGroupOptions[] {
  let groupOptions: IGroupOptions[] = [];
  if (Array.isArray(data) && data.length) {
    groupOptions = data.map(item => {
      const children = item[childrenKey];
      // const label = item[labelKey];
      // const value = item[valueKey];
      if (Array.isArray(children) && children.length) {
        return {
          label: item[groupLabelKey],
          value: item[groupValueKey],
          children: dataToOptionData(
            children,
            labelKey,
            valueKey,
            childrenKey,
            groupLabelKey,
            groupValueKey,
          ),
        };
      }
      return { label: item[labelKey], value: item[valueKey] };
    });
  }
  return groupOptions;
}

export function getSelectItem(list: any, value: string, dataIndex: string) {
  let data: any = {};
  matchArr(list) &&
    list.map((item: any) => {
      if (item[dataIndex] === value) {
        data = item;
      }
    });
  return data;
}

export function matchString(text: string) {
  return text !== null && text !== undefined && text !== '';
}

export function matchArr(arr: any) {
  return (
    arr !== null && arr !== undefined && arr !== '' && typeof arr === 'object'
  );
}
/** 获取下拉选的选项 */
export function selectOption(data: [], labelStr: string, valueStr: string) {
  const list: any = [];
  (data ?? []).map((item: any, index: number) => {
    const o = {
      value: `${item[valueStr]}`,
      label: `${item[labelStr]}`,
      key: index,
    };
    list.push(o);
  });
  return list;
}
